export default __webpack_public_path__ + "static/media/bleedingpuncture1.720ba818.png";